import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthService } from '@Services';
import { FooterComponent } from '../footer/footer.component';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { HeaderComponent } from '../header/header.component';
import { StatusBarComponent } from '../status-bar/status-bar.component';
import { SkipLinkComponent } from '../skip-link/skip-link.component';

@Component({
  selector: 'app-layout',
  imports: [
    RouterOutlet,
    FooterComponent,
    DisclaimerComponent,
    HeaderComponent,
    StatusBarComponent,
    SkipLinkComponent,
    AsyncPipe,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
})
export class LayoutComponent {
  @Input() isIframe = false;

  constructor(private _authService: AuthService) {}
  isLogged() {
    return this._authService.isLoggedIn();
  }
}
